/**
 * Recursively removes undefined values from an object or array.
 * Firestore writes reject undefined values at any depth.
 */
export function removeUndefinedValues<T>(value: T): T {
  if (value === null) {
    return value;
  }

  if (Array.isArray(value)) {
    return value.map(removeUndefinedValues) as T;
  }

  if (value instanceof Date) {
    return value;
  }

  if (typeof value === "object") {
    const cleaned = {} as T;

    for (const [key, val] of Object.entries(value)) {
      if (val === undefined) {
        continue;
      }

      (cleaned as Record<string, unknown>)[key] = removeUndefinedValues(val);
    }

    return cleaned;
  }

  return value;
}
